export default "__VITE_ASSET__qfS2zaxj__"